import {ELeadClientStatus, ERegistrationType} from './definitions';

export default {
  title: 'Лиды',
  addClient: 'лид',
  searchPlaceholder: 'быстрый поиск по лиду',
  createLink: 'Создать ссылку',
  personalTariff: 'Индивидуальный тариф',
  status: {
    [ELeadClientStatus.WAITING]: 'Лид',
    [ELeadClientStatus.REQUIRES_ATTENTION]: 'Требует внимания',
    [ELeadClientStatus.DRAFT]: 'Контакт',
    [ELeadClientStatus.ACCEPTED]: 'Активный',
    [ELeadClientStatus.ERROR]: 'Заблокирован',
    [ELeadClientStatus.CANCELLED]: 'Просрочен',
  },
  th: {
    createdAt: 'Дата создания',
    company: 'Компания',
    status: 'Статус',
    type: 'Тип лида',
  },
  leadType: {
    base: 'Обычный лид',
    contact: 'Контакт',
    selfRegistered: 'Саморегистрация',
  },
  filters: {
    title: 'Фильтры',
    statusLabel: 'Статус',
    createdAtLabel: 'Дата регистрации',
    managerLabel: 'Ответственный менеджер',
    managerPlaceholder: 'Выберите менеджера',
    resellerLabel: 'Юрисдикция',
    resellerPlaceholder: 'Выберите юрлицо',
    leadClients: 'Клиентов',
    registrationType: 'Тип регистрации',
    registrationTypes: {
      [ERegistrationType.SELF_SERVICE]: 'Саморегистрация',
      [ERegistrationType.ADMIN_CREATED]: 'Ручное создание',
    },
  },
  notification: {
    updateResponsibleManager: 'Ответственный менеджер успешно изменен',
  },
  createInviteLinkModal: {
    title: 'Создать ссылку регистрации для клиента?',
    titleAgent: 'Создать ссылку регистрации для агента?',
    text: 'Логином для регистрации будет e-mail контактного лица клиента',
    textAgent: 'Логином для регистрации будет e-mail контактного лица агента',
    tariffsWarning: 'После создания ссылки редактирование тарифов Лида будет недоступно.',
  },
  copyInviteLinkModal: {
    inviteLink: 'Ссылка регистрации для клиента',
    inviteLinkAgent: 'Ссылка регистрации для агента',
    copyLink: 'Скопируйте и отправьте эту ссылку клиенту чтобы он мог войти в edna Pulse.',
    copyLinkAgent: 'Скопируйте и отправьте эту ссылку агенту чтобы он мог войти в edna Pulse.',
    linkIsValid: 'Помните, ссылка действительна 72 часа',
    link: 'Ссылка для регистрации',
    wellDone: 'Отлично',
  },
  leadClientCard: {
    leadType: 'Тип лида',
    selfRegistered: 'Саморегистрация',
    licenseStatus: 'Статус лицензии',
    expiredAt: 'Лицензия действительна до',
    responsibleManager: 'Ответственный менеджер edna',
    partner: 'Агент',
    taxNumber: 'ИНН',
    binNumber: 'Бизнес-идентификационный номер (БИН)',
    ogrn: 'ОГРН/ОГРНИП',
    country: 'Страна',
    currency: 'Валюта',
    reseller: 'Юрисдикция',
    document: 'Договор',
    documentName: '{{documentNumber}} от {{documentDate}}',
    contact: 'Контактное лицо клиента',
    contactName: 'ФИО',
    phone: 'Телефон',
    email: 'e-mail',
    companyName: 'Название организации',
    companyData: 'Данные компании',
    companyLicenses: 'Лицензии компании',
    settlementRules: 'Правила взаиморасчетов',
    paymentType: 'Тип оплаты',
    managerResponsibleForCheckingId: 'Ответственный за проверку компании',
    depositAmount: 'Размер обеспечительного платежа',
    overdraftAmount: 'Размер овердрафта',
    activateLicenseDebt: 'Активация лицензии в долг',
    paymentPeriod: 'Срок оплаты лицензии',
    cancellationPeriod: 'Срок до аннулирования лицензии при неоплате',
    allowed: 'разрешена',
    notAllowed: 'не разрешена',
    tariffs: 'Тарифы',
    empty: 'Не указано',
    responsibleManagerModal: {
      title: 'Изменить ответственного менеджера',
      selectManager: 'Выберите ответственного менеджера',
    },
    validDate: 'Действительна с {{activatedAt}} до {{validUntil}}',
  },
};
